module.exports = __webpack_public_path__ + "static/media/icons_rachis_lomabire.1f9fd1e4.svg";